import { render } from "./wpProductList.vue?vue&type=template&id=7bee5c52&scoped=true"
import script from "./wpProductList.vue?vue&type=script&lang=js"
export * from "./wpProductList.vue?vue&type=script&lang=js"

import "./wpProductList.vue?vue&type=style&index=0&id=7bee5c52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bee5c52"]])

export default __exports__